import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'


import { Identity } from '../features/identity';

const router = createRouter({
  history: createWebHistory(),
  routes,
})


router.beforeEach((to, from, next) => {
  const identity = new Identity();
  if (to.matched.some(record => record.meta.nonAuthRequired)) {
    if(to.path == '/Login' && identity.IsAuthenticated){
      next({
        path: '/'
      })
    }else{
      next()
    }
  } else {
    if(!identity.IsAuthenticated){
      next({
        path: '/Login'
      })
    }else{
      next()
    }
  }
});


export default router;
